import React from 'react';
import classNames from 'classnames';
import Wait from '@react/react-spectrum/Wait';

import '../scss/Wait.scss';

export default (props) => {
    const {
        size = 'M',
        className = '',
        indeterminate = true,
        ...otherProps
    } = props;

    if (!indeterminate) {
        return <Wait {...props} />;
    }

    return (
        <div
            className={classNames(
                'simplified-wait',
                {
                    'simplified-wait--small': (size === 'S'),
                    'simplified-wait--medium': (size === 'M'),
                    'simplified-wait--large': (size === 'L'),
                },
                className,
            )}
            {...otherProps}
        />
    );
};
